import { useState } from "react"
import { ColorSampleFilter } from "./ColorSample"
import { v4 } from "uuid"

const useColorSampleState = () => {
    const [samples, setColorSamples] = useState<(ColorSampleFilter & { id: string })[]>([])

    return {
        addSample: (sample: ColorSampleFilter) => {
            setColorSamples((prev) => [...prev, { ...sample, id: v4() }])
        },
        removeSample: (...ids: string[]) => {
            setColorSamples((prev) => prev.filter((sample) => !ids.includes(sample.id)))
        },
        samples: samples,
    }
}

export { useColorSampleState }
